import { DefaultTheme } from "styled-components";
import { colors } from "./constants/colors";
import { fonts } from "./constants/fonts";

const theme: DefaultTheme = { colors, fonts };

export default theme;
